import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import { Grid } from "@mui/material";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";

/**
 *
 * @param {Object} value {SalesOrganizationName,SalesOrganizationID}
 * @returns "{value,label,SalesOrganizationName,SalesOrganizationID}"
 */

const SAPCustomerSalesOrgPicker = ({
  title,
  value,
  required,
  updatefunc,
  multi = false,
  isCreatable = false,
  customer = "",
}) => {
  const { instance, accounts } = useMsal();
  const getData = (input) =>
    new Promise((resolve) => {
      let fetchOptions = {
        method: "POST",
        credentials: "same-origin",

        body: JSON.stringify({
          proj: "Z_GW_ARCH_ORDER_SRV",
          funct: "SalesOrgSet",
          parameters: `$format=json&$filter=CustomerID eq '${customer}' and SalesOrgID eq '*${input}*'`,
        }),
      };
      var sys = window.localStorage.getItem("QUOTEsys");
      let url = `SAPOData${sys}`;
      return apiCall(
        url,
        fetchOptions,
        (json) =>
          resolve(
            json.map((result) => ({
              Name: result.SalesOrgName,
              Id: result.SalesOrgID,
              value: result.SalesOrgName,
              label: result.SalesOrgName + " (" + result.SalesOrgID + ")",
            }))
          ),
        instance,
        accounts
      );
    });

  const lstore = useLocalStore(() => ({
    onChange(newVal, actionMeta) {
      if (newVal !== null) {
        if (multi) {
          if (isCreatable && actionMeta.action === "create-option")
            newVal.forEach((element) => {
              if (element.__isNew__) {
                element.Name = element.label;
                element.Id = "0";
              }
            });
          updatefunc(newVal);
        } else {
          if (newVal.__isNew__) {
            newVal.Name = newVal.label;
            newVal.Id = "0";
          }
          updatefunc(newVal);
        }
      } else {
        updatefunc(null);
      }
    },
  }));

  return (
    <Grid container spacing={0} direction="column">
      <Grid item xs>
        <label>
          {title}
          {required && " *"}
        </label>
      </Grid>
      <Grid item xs>
        <EOCAsyncSelect
          cy={title}
          isMulti={multi}
          loadOptions={getData}
          value={value}
          updateF={lstore.onChange}
          clearAble={isCreatable}
          isCreatable={isCreatable}
          isSearchable={true}
          defaultOptions
        />
      </Grid>
    </Grid>
  );
};

export default observer(SAPCustomerSalesOrgPicker);
